import React from 'react';

const HeaderEnd = ({ content }) => {
  return <></>;
};
export default HeaderEnd;
